// WeiterHinweis.jsx — Formen- und SV-Panel (21.10.2026)
import React from 'react';
import './WeiterHinweis.css';

// Hinweis im Panel: die nächste Kategorie der Matte ist eine andere Art
// (Kampf, Bruchtest) oder gehört ins andere Panel. Sie ist schon aufgerufen;
// hier steht, wo sie läuft, mit Link.
export default function WeiterHinweis({ hinweis, onSchliessen, onWechseln = null }) {
  const z = hinweis.ziel || {};
  const oeffnen = (pfad) => window.open(pfad, '_blank', 'noopener');
  return (
    <div className="weiter-hinweis-jp" role="status">
      <div className="weiter-hinweis-text">
        <strong>Als Nächstes{hinweis.matte ? ` auf Matte ${hinweis.matte}` : ''}: {hinweis.kategorie_name}</strong>
        <span>
          {z.art_text || 'Andere Art'}{hinweis.teilnehmer_anzahl ? ` · ${hinweis.teilnehmer_anzahl} Starter` : ''}
          {' · '}{hinweis.wartet ? 'wird nach dem Siegerbild aufgerufen' : hinweis.laeuft_schon ? 'läuft bereits, nicht erneut aufgerufen' : hinweis.aufruf ? 'in der Halle aufgerufen' : 'nicht in der Halle aufgerufen'}
          {' · '}Ort: {z.panel || 'anderes Panel'}
        </span>
        {hinweis.erster_kampf && (
          <span>Erster Kampf: {hinweis.erster_kampf.rot || '?'} gegen {hinweis.erster_kampf.blau || '?'}</span>
        )}
      </div>
      {onWechseln && <button className="weiter-hinweis-knopf" onClick={onWechseln}>Hier wechseln</button>}
      {!onWechseln && z.pfad && <button className="weiter-hinweis-knopf" onClick={() => oeffnen(z.pfad)}>{z.panel || 'Panel'} öffnen</button>}
      {z.schirm && <button className="weiter-hinweis-knopf" onClick={() => oeffnen(z.schirm)}>Mattenschirm öffnen</button>}
      <button className="weiter-hinweis-knopf" onClick={onSchliessen} title="Hinweis ausblenden">Ausblenden</button>
    </div>
  );
}

